import React from 'react';
import * as RT from '../../../constants/Routing';
import * as SG from '../../../constants/AppSettings'
import { Link } from 'react-router-dom';
import defaultPhoto from '../../../lib/images/user-thumb-default.png';
import UserCard from '../ProfileCard';


export default class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'user[name]': props.App.currentUser.name || '',
      'user[email]': props.App.currentUser.email || '',
      'user[birthday]': props.App.currentUser.birthday || '',
      'user[photo]': props.App.currentUser.photo || '',
      'user[gender]': props.App.currentUser.gender || '',
      'user[phone_number]': props.App.currentUser.phone_number || '',
    };
  };

  valueChange = (e) => {
    const currentUser = this.props.App.currentUser
    if (e.target.name === 'user[photo]') {
      const fileSelectDom = e.target;
      const filePreviewBox = document.querySelector('.user-thumb-form')
      const photo = currentUser.photo ? currentUser.photo : defaultPhoto

      const isValidFile = this.validateFileExtensions(e.target.files[0])

      if (isValidFile) {
        let fileReader = new FileReader();
        fileReader.onload = () => {
          filePreviewBox.style.backgroundImage = `url(${fileReader.result})`
        }
        fileReader.readAsDataURL(fileSelectDom.files[0])
        fileReader.onload()
      } else {
        if (!fileSelectDom.files.length) {
          filePreviewBox.style.backgroundImage = `url(${photo})`
        }
        
        e.target.value = ''
      }

    }

    this.setState({ [e.target.name]: e.target.value })
  }

  validateFileExtensions = (file) => {
    var validFileExtensions = ["jpg", "jpeg", "gif", "png"];
    var fileErrors = new Array();

    var ext = file.name.split('.').pop();

    if (validFileExtensions.indexOf(ext) == -1) {
      fileErrors.push('画像は jpg, jpeg, gif, png のいずれかのフォーマットのものを選択する必要があります。')
    }

    if (file.size >= SG.FILE_SIZE_LIMIT) {
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
      let ext = sizes[0];
      let size = SG.FILE_SIZE_LIMIT

      if (typeof size === 'number') {
        for (var i = 1; i < sizes.length; i += 1) {
          if (size >= 1024) {
            size = size / 1024;
            ext = sizes[i];
          }
        }
      }

      const limit = this.round(size, 2) + ext;

      fileErrors.push(`ファイルの容量が大きすぎます。 ${limit} 以下のサイズのファイルを選択して下さい。`)
    }

    if (fileErrors.length > 0) {
      this.props.noticeInEdit(fileErrors, 'error')
      return false;
    }
    return true;
  }

  round = (value, precision, mode) => {
    // http://kevin.vanzonneveld.net
    // +   original by: Philip Peterson
    // +    revised by: Onno Marsman
    // +      input by: Greenseed
    // +    revised by: T.Wild
    // +      input by: meo
    // +      input by: William
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Josep Sanz (http://www.ws3.es/)
    // +    revised by: Rafa? Kukawski (http://blog.kukawski.pl/)
    // %        note 1: Great work. Ideas for improvement:
    // %        note 1:  - code more compliant with developer guidelines
    // %        note 1:  - for implementing PHP constant arguments look at
    // %        note 1:  the pathinfo() function, it offers the greatest
    // %        note 1:  flexibility & compatibility possible
    // *     example 1: round(1241757, -3);
    // *     returns 1: 1242000
    // *     example 2: round(3.6);
    // *     returns 2: 4
    // *     example 3: round(2.835, 2);
    // *     returns 3: 2.84
    // *     example 4: round(1.1749999999999, 2);
    // *     returns 4: 1.17
    // *     example 5: round(58551.799999999996, 2);
    // *     returns 5: 58551.8
    var m, f, isHalf, sgn; // helper variables
    precision |= 0; // making sure precision is integer
    m = Math.pow(10, precision);
    value *= m;
    sgn = (value > 0) | -(value < 0); // sign of the number
    isHalf = value % 1 === 0.5 * sgn;
    f = Math.floor(value);

    if (isHalf) {
      switch (mode) {
        case 'PHP_ROUND_HALF_DOWN':
          value = f + (sgn < 0); // rounds .5 toward zero
          break;
        case 'PHP_ROUND_HALF_EVEN':
          value = f + (f % 2 * sgn); // rouds .5 towards the next even integer
          break;
        case 'PHP_ROUND_HALF_ODD':
          value = f + !(f % 2); // rounds .5 towards the next odd integer
          break;
        default:
          value = f + (sgn > 0); // rounds .5 away from zero
      }
    }

    return (isHalf ? value : Math.round(value)) / m;

  }

  checkAllEnter = () => {
    // 全入力チェック
    if (!!this.state['user[name]'] && !!this.state['user[email]'] && !!this.state['user[birthday]'] && !!this.state['user[gender]']) {
      return true
    } else {
      return false
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    
    const form = document.getElementById('user-first-form')
    const fileInput = document.querySelector('.thumb-field')
    // console.log('profile edit', fileInput.files.length,fileInput.files)
    if (!fileInput.files.length) fileInput.setAttribute('disabled', '')
    const formData = new FormData(form)
    fileInput.removeAttribute('disabled')
    this.props.updateMyProfile(formData)
  }

  componentDidMount = () => {
    const userThumbBox = document.querySelector('.user-thumb-form')
    function clickFileInput() {
      const fileInput = document.querySelector('.thumb-field')
      fileInput.click()
    }
    userThumbBox.addEventListener('click', clickFileInput)
  }

  render = () => {

    const currentUser = this.props.App.currentUser
    const currentPath = this.props.location.pathname
    
    return (
      <form id='user-first-form' className='' onSubmit={this.onSubmit}>
        <div className='container'>
          <UserCard user={currentUser} currentPath={currentPath} />

          <h2 className='mt0 headline'>プロフィールの編集</h2>

          <table className='table table-borderless'>
            <tbody>
              <input type='file' name='user[photo]' className='d-none thumb-field ' onChange={this.valueChange} accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png" />
              {/* <tr>
                <th><label htmlFor="user[photo]">サムネイル</label></th>
                <td>
                  <div className='user-thumb-form shadow-sm' style={thumbStyle}>
                    <input type='file' name='user[photo]' className='d-none thumb-field ' onChange={this.valueChange} />
                    <i className="material-icons">add</i>
                  </div>
                </td>
              </tr> */}
              <tr>
                <th><label htmlFor='user[name]'>名前</label></th>
                <td><input type='text' name='user[name]' value={this.state['user[name]']} onChange={this.valueChange} required /></td>
              </tr>
              <tr>
                <th><label htmlFor='user[phone_number]'>電話番号<br />(ハイフンあり)</label></th>
                <td><input type='text' name='user[phone_number]' value={this.state['user[phone_number]']} onChange={this.valueChange} required /></td>
              </tr>
              <tr>
                <th><label htmlFor='user[email]'>メール</label></th>
                <td><input type='email' name='user[email]' value={this.state['user[email]']} onChange={this.valueChange} required /></td>
              </tr>
              <tr>
                <th><label htmlFor='user[gender]'>性別</label></th>
                <td>
                  <div className='radio-wrap'>
                    <input type="radio" name="user[gender]" value="male" id="male" checked={this.state["user[gender]"] === "male"} onChange={this.valueChange} />
                    <label htmlFor="male">男性</label>
                  </div>
                  <div className='radio-wrap'>
                    <input type="radio" name="user[gender]" value="female" id="female" checked={this.state["user[gender]"] === "female"} onChange={this.valueChange} />
                    <label htmlFor="female">女性</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          {(() => {
            if (this.checkAllEnter()) {
              return (
                <input type='submit' className='btn btn-submit d-block btn-block' value='更新する' />
              )
            } else {
              return (
                <input type="submit" className='btn btn-submit disabled d-block btn-block' disabled value='更新する' />
              )
            }
          })()}
          <Link to={RT.USER_MYPAGE_PATH} className='btn btn-primary d-block btn-block'>マイページに戻る</Link>
        </div>
      </form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/ProfileEdit/ProfileEdit.jsx